import { jsPDF } from "jspdf";
import { PlayField } from "@/components/field/PlayField";
import { svgToPng, toStaticSvg } from "@/lib/pdf";
import { POSITIONS } from "@/lib/jobs";

export function lineupPositions(cfg, lineup) {
  return Object.fromEntries(POSITIONS.map((pos) => {
    const names = lineup.entries.filter((e) => e.position === pos).map((e) => e.name);
    return [pos, { pos, pt: cfg.ready[pos], job: names.length ? "cover_1b" : "hold", label: names.join(" / ") || "Open" }];
  }));
}

export const offField = (lineup) => lineup.entries.filter((e) => !POSITIONS.includes(e.position));

export const LineupField = ({ cfg, lineup, still }) => (
  <PlayField cfg={cfg} runners={0} positions={lineupPositions(cfg, lineup)} throws={[]} runnerPaths={[]} hit={null}
    showLabels still={still} playId="lineup" />
);

export async function exportLineupCard(lineup, cfg, teamName) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const M = 40;
  const W = 612 - M * 2;
  doc.setFont("helvetica", "bold").setFontSize(10).setTextColor(90).text(`DIAMONDPLAY  ·  ${teamName.toUpperCase()}`, M, M);
  doc.setFontSize(24).setTextColor(15).text(lineup.name, M, M + 30);
  let y = M + 58;
  doc.setFillColor(15, 23, 42).rect(M, y - 14, 250, 20, "F");
  doc.setFontSize(10).setTextColor(255).text("#", M + 8, y).text("PLAYER", M + 32, y).text("POS", M + 210, y);
  y += 20;
  lineup.entries.forEach((e, i) => {
    if (i % 2 === 0) doc.setFillColor(241, 245, 249).rect(M, y - 13, 250, 19, "F");
    doc.setFont("helvetica", "bold").setFontSize(12).setTextColor(15).text(`${i + 1}`, M + 8, y);
    doc.setFont("helvetica", "normal").text(e.name, M + 32, y, { maxWidth: 170 });
    doc.setFont("helvetica", "bold").text(e.position, M + 210, y);
    y += 19;
  });
  const fx = M + 265;
  const fw = W - 265;
  const fh = (fw * 1.19) / 1.44;
  const svg = toStaticSvg(<LineupField cfg={cfg} lineup={lineup} still />);
  doc.addImage(await svgToPng(svg, 1440, 1190), "JPEG", fx, M + 44, fw, fh);
  const bench = offField(lineup);
  let by = M + 44 + fh + 20;
  if (bench.length) {
    doc.setFont("helvetica", "bold").setFontSize(11).text("OFF THE FIELD", fx, by);
    doc.setFont("helvetica", "normal").setFontSize(10);
    bench.forEach((e) => { by += 15; doc.text(`${e.position}: ${e.name}`, fx, by); });
  }
  y = Math.max(y, by) + 24;
  if (lineup.notes) {
    doc.setFont("helvetica", "bold").setFontSize(11).text("COACHES' NOTES", M, y);
    doc.setFont("helvetica", "normal").setFontSize(10).text(doc.splitTextToSize(lineup.notes, W), M, y + 15);
  }
  doc.save(`${teamName}-${lineup.name}-lineup.pdf`);
}
